import { create } from 'zustand';
import type { Commons } from '../shared/scene';
import type { AppConfig, SelfReport } from './lib/api';
import type { LocalPlay } from './lib/localDb';

interface AppStore {
  config?: AppConfig;
  commons?: Commons;
  selfReport?: SelfReport;
  localPlays: LocalPlay[];
  setConfig: (config: AppConfig) => void;
  setCommons: (commons: Commons) => void;
  setSelfReport: (report?: SelfReport) => void;
  setLocalPlays: (plays: LocalPlay[]) => void;
}

export const useAppStore = create<AppStore>((set) => ({
  localPlays: [],
  setConfig: (config) => set({ config }),
  setCommons: (commons) => set({ commons }),
  setSelfReport: (selfReport) => set({ selfReport }),
  setLocalPlays: (localPlays) => set({ localPlays })
}));
